function Toggle(element: HTMLElement) {
  const toggle = element.querySelector('.toggle');

  if (toggle) {
    const showMore = toggle.getAttribute('data-label-more');
    const showLess = toggle.getAttribute('data-label-less');
    const hideDefaultContent = toggle.getAttribute('data-hide-default-content') != 'false';
    const isLongField = toggle.getAttribute('data-long-field') == 'true';
    const isDefaultOpen = toggle.getAttribute('data-default-open') == 'true';
    const isOnOneRow = toggle.getAttribute('data-on-one-row') == 'true';
    const maxLines = isOnOneRow ? '1' : isLongField ? '16' : '4';

    const content = element.querySelector('.content');
    const contentStyleClass = hideDefaultContent ? 'hidden' : `line-clamp-${maxLines}`;

    // eslint-disable-next-line no-inner-declarations
    function show() {
      toggle.textContent = showLess;
      content.classList.remove(contentStyleClass);
    }

    // eslint-disable-next-line no-inner-declarations
    function hide() {
      content.classList.add(contentStyleClass);
      toggle.textContent = showMore;
    }

    toggle.addEventListener('click', function () {
      toggle.toggleAttribute('aria-expanded');
      toggle.textContent.includes(showMore) ? show() : hide();
    });

    let paragraphsLength = 0;
    const paragraphs = content.getElementsByTagName('p');
    [...paragraphs].forEach((p) => {
      paragraphsLength += p.textContent.length;
    });

    const smallParagrapheLength = 125 * Number(maxLines);
    const longParagrapheLength = 155 * Number(maxLines);

    const isShortParagraphs = isLongField
      ? paragraphs && paragraphsLength < longParagrapheLength
      : paragraphs && paragraphsLength < smallParagrapheLength;

    if (isShortParagraphs && !hideDefaultContent) {
      toggle.classList.add('hidden');
    } else {
      content.classList.add(contentStyleClass);
    }

    if (isDefaultOpen) {
      toggle.toggleAttribute('aria-expanded');
      show();
    }
  }
}

const showMoreLines = {
  init: () => {
    document
      .querySelectorAll('.container-show-more-lines')
      .forEach((element) => Toggle(element as HTMLElement));
  },
};

export default showMoreLines;
